import { AttachmentFile, Dtos, ExtractionStatus } from "@inrev/common";

export type FinancialExtraction = Dtos.FinancialExtraction.Get.Response;

export type ContractExtraction = Dtos.ContractExtraction.Get.Response;

export type WipExtraction = Dtos.Wip.Extraction.Get.Response;

export type BondRequestExtractionListItem = Pick<
	Dtos.BondRequestExtraction.List.Response[number],
	"id" | "status"
>;

export type UploadedDocumentFilter =
	| "all"
	| "financials"
	| "personal_financials"
	| "work_in_progress"
	| "company"
	| "banking"
	| "other";

export type UploadedDocumentCategory = Exclude<UploadedDocumentFilter, "all">;

export type UploadedDocumentRow = AttachmentFile & {
	financialExtraction?: FinancialExtraction;
	contractExtraction?: ContractExtraction;
	wipExtraction?: WipExtraction;
	bondRequestExtraction?: BondRequestExtractionListItem;
};

export function isViewableBondRequestExtraction(
	extraction: BondRequestExtractionListItem | undefined,
): extraction is BondRequestExtractionListItem {
	return (
		extraction != null &&
		(extraction.status === ExtractionStatus.Completed ||
			extraction.status === ExtractionStatus.Partial)
	);
}
